export let activitiesOverTimeOptions = {
  series: [{
    name: 'Successful',
    data: [76, 85, 101, 98, 87, 105, 91, 14, 94, 2, 24, 63]
  }, {
    name: 'Cancelled',
    data: [44, 15, 27, 76, 11, 58, 13, 20, 26, 55, 9, 23]
  }, {
    name: 'Processing',
    data: [35, 41, 36, 26, 45, 48, 52, 53, 41, 5, 0, 0]
  }, {
    name: 'Failed',
    data: [25, 31, 16, 6, 25, 10, 20, 13, 11, 25, 84, 88]
  }],
    chart: {
    type: 'bar',
    height: 350,
    fontFamily: 'Poppins, sans-serif',
    toolbar: {
      show: false
    },
  },
  colors: ['#009688', '#e2a03f','#2196f3','#e7515a'],
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: '55%',
      endingShape: 'rounded'
    },
  },
  dataLabels: {
    enabled: false
  },
  stroke: {
    show: true,
    width: 2,
    colors: ['transparent']
  },
  xaxis: {
    categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    labels: {
      offsetX: 0,
      offsetY: 0,
      style: {
          fontSize: '12px',
          fontFamily: 'Poppins, sans-serif',
          cssClass: 'apexcharts-yaxis-title',
      },
    }
  },
  yaxis: {
  labels: {
      offsetX: -22,
      offsetY: 0,
      style: {
          fontSize: '12px',
          fontFamily: 'Poppins, sans-serif',
          cssClass: 'apexcharts-yaxis-title',
      },
    }
  },
  grid: {
    borderColor: '#e0e6ed',
    strokeDashArray: 8,
    xaxis: {
        lines: {
            show: true
        }
    },
    yaxis: {
        lines: {
            show: true,
        }
    },
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: -10
    },
  },
  legend: {
    show: false,
  },
  fill: {
    opacity: 1
  },
  tooltip: {
    theme: 'dark',
    marker: {
      show: true,
    },
    x: {
      show: false,
    }
  },
}

export let documentAccessByDepartmentOptions = {
  series: [{
    name: 'Target Sales',
    type: 'column',
    data: [4400, 5050, 4140, 6710, 2270, 4130, 2010, 3520, 7520, 3200, 2570, 1600]
  }, {
    name: 'Total Achieve',
    type: 'line',
    data: [4000, 5100, 4500, 6000, 2000, 4000, 2090, 3500, 7000, 3000, 2800, 2000]
  }],
    chart: {
    height: 350,
    type: 'line',
    fontFamily: 'Poppins, sans-serif',
    toolbar: {
      show: false
    },
  },
  stroke: {
    width: [0, 4]
  },
  colors: ['#2262c6', '#e7515a'],
  dropShadow: {
    enabled: true,
    opacity: 0.2,
    blur: 5,
    left: -7,
    top: 22
  },
  dataLabels: {
    enabled: true,
    enabledOnSeries: [1],
    style: {
      colors: ['#ffffff', '#e7515a'],
      fontSize: '12px',
      fontFamily: 'Poppins, sans-serif',
      cssClass: 'apexcharts-yaxis-title',
    },
  },
  plotOptions: {
    bar: {
      columnWidth: '25%',
    },
  },
  labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  yaxis: [{
    labels: {
      offsetX: -15,
      offsetY: 0,
      style: {
          fontSize: '12px',
          fontFamily: 'Poppins, sans-serif',
          cssClass: 'apexcharts-yaxis-title',
      },
    }
  },{
    opposite: true,
    labels: {
      offsetX: -10,
      offsetY: 0,
      style: {
          fontSize: '12px',
          fontFamily: 'Poppins, sans-serif',
          cssClass: 'apexcharts-yaxis-title',
      },
    }
  }],
  xaxis: {
    // type: 'datetime',
    categories: null,
    labels: {
      show: false,
      offsetX: 0,
      offsetY: 5,
      style: {
          fontSize: '12px',
          fontFamily: 'Poppins, sans-serif',
          cssClass: 'apexcharts-xaxis-title',
      },
    }
  },
  legend: {
    show: false
  },
  tooltip: {
    theme: 'dark',
    marker: {
      show: true,
    },
    x: {
      show: false,
    }
  },
  grid: {
    borderColor: '#e0e6ed',
    strokeDashArray: 8,
    xaxis: {
      lines: {
        show: true
      }
    },
    yaxis: {
      lines: {
        show: true,
      }
    },
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: -10
    },
  },
}

export let domainsWhereDocumentWasSentOptions = {
  series: [44, 55, 13, 33],
  chart: {
    type: 'pie',
    height: 350,
    fontFamily: 'Poppins, sans-serif',
  },
  labels: ['Team A', 'Team B', 'Team C', 'Team D'],
  colors: ['#009688', '#E91E63', '#2196F3', '#FF5722', '#673AB7', '#FFC107', '#4CAF50', '#9C27B0', '#FF9800', '#3F51B5', '#FFEB3B', '#03A9F4', '#FF9800', '#8BC34A', '#795548', '#CDDC39', '#607D8B', '#FF5252', '#9E9E9E', '#00BCD4'],
  plotOptions: {
    pie: {
      expandOnClick: false,
      donut: {
        size: '70%'
      }
    }
  },
  legend: {
    show: false
  },
  tooltip: {
    theme: 'dark',
    marker: {
      show: true,
    },
    y: {
      formatter: function(value) {
        return value;
      }
    }
  },
};
